import React, { useState } from 'react';
import { Clock, Mail, Phone } from 'lucide-react';
import styles from './ContactsOnCall.module.css';
import bgPattern from '../../../../Assets/BRANDING-BG.png';
import { Header } from '../header/Header';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';

const ACCOUNT_LEADERSHIP = [
    {
        title: 'Customer Success Manager (CSM)',
        name: 'Sudesh J Sonki',
        hours: '9:00 AM - 6:00 PM EST',
        email: 'sudesh.sonki@kochasoft.com',
        phone: '+1 (555) 234-5678'
    },
    {
        title: 'Service Delivery Manager (SDM)',
        name: 'Amol Pawde',
        hours: '9:00 AM - 6:00 PM EST',
        email: 'amol.pawde@kochasoft.com',
        phone: '+1 (555) 234-5678'
    },
    {
        title: 'Technical Manager',
        name: 'Bernardt Nel',
        hours: '9:00 AM - 6:00 PM EST',
        email: 'bernardt.nel@kochasoft.com',
        phone: '+1 (555) 234-5678'
    }
];

const TECHNICAL_HIERARCHY = {
    commandCenter: {
        title: 'Command Center Lead',
        name: 'Sonam Kumari',
        hours: '9:00 AM - 6:00 PM EST'
    },
    engineers: [
        [
            { level: 'L4 Engineer', name: 'Arunkumar Lavishetty', hours: '9:00 AM - 6:00 PM EST' },
            { level: 'L3 Engineer', name: 'Ragavendran Rajendran', hours: '9:00 AM - 6:00 PM EST' },
            { level: 'L3 Engineer', name: 'Shambuling Bagalkoti', hours: '9:00 AM - 6:00 PM EST' }
        ]
    ]
};

export const ContactsOnCall = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.headerWrapper}>
                <Header onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            </div>

            <div className={styles.mainWrapper}>
                <DashboardSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />

                <div className={styles.container} style={{ backgroundImage: `url(${bgPattern})` }}>
                    <div className={styles.pageHeader}>
                        <div className={styles.headerContent}>
                            <h1 className={styles.title}>Contacts & On-Call</h1>
                            <p className={styles.subtitle}>
                                Account ownership, escalation hierarchy, and on-call visibility
                            </p>
                        </div>
                        <div className={styles.lastUpdated}>
                            Last updated: <strong>Jan 15, 2026 at 09:00 AM</strong>
                        </div>
                    </div>

                    {/* Account Leadership Section */}
                    <section className={styles.section}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.sectionTitle}>Account Leadership</h2>
                            <span className={styles.sectionLabel}>Primary Contacts</span>
                        </div>

                        <div className={styles.leadershipGrid}>
                            {ACCOUNT_LEADERSHIP.map((contact, index) => (
                                <div key={index} className={styles.leadershipCard}>
                                    <h3 className={styles.contactTitle}>{contact.title}</h3>
                                    <p className={styles.contactName}>{contact.name}</p>
                                    <div className={styles.contactInfo}>
                                        <div className={styles.infoItem}>
                                            <Clock size={16} />
                                            <span>{contact.hours}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <Mail size={16} />
                                            <span>{contact.email}</span>
                                        </div>
                                        <div className={styles.infoItem}>
                                            <Phone size={16} />
                                            <span>{contact.phone}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Technical & On-Call Hierarchy Section */}
                    <section className={styles.section}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.sectionTitle}>Technical & On-Call Hierarchy</h2>
                            <span className={styles.sectionLabel}>Escalation Pyramid</span>
                        </div>

                        {/* Command Center Lead */}
                        <div className={styles.commandCenterWrapper}>
                            <div className={styles.commandCenterCard}>
                                <h3 className={styles.contactTitle}>
                                    {TECHNICAL_HIERARCHY.commandCenter.title}
                                </h3>
                                <p className={styles.contactName}>
                                    {TECHNICAL_HIERARCHY.commandCenter.name}
                                </p>
                                <div className={styles.contactInfo}>
                                    <div className={styles.infoItem}>
                                        <Clock size={16} />
                                        <span>{TECHNICAL_HIERARCHY.commandCenter.hours}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Engineers Rows */}
                        {TECHNICAL_HIERARCHY.engineers.map((row, rowIndex) => (
                            <div
                                key={rowIndex}
                                className={styles.engineersRow}
                            >
                                {row.map((engineer, index) => (
                                    <div key={index} className={styles.engineerCard}>
                                        <h3 className={styles.engineerLevel}>{engineer.level}</h3>
                                        <p className={styles.engineerName}>{engineer.name}</p>
                                        <div className={styles.contactInfo}>
                                            <div className={styles.infoItem}>
                                                <Clock size={16} />
                                                <span>{engineer.hours}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ContactsOnCall;
